export const handleErrorUpgradeAccount = (
  error: any,
  onError: (message: string) => void,
): void => {
  const errorMessage =
    error.response?.data?.error ||
    'An error occurred during the account upgrade.';
  onError(errorMessage);
  console.error(errorMessage, error);
};
